import { render } from "./report-overview.vue?vue&type=template&id=65992340&scoped=true"
const script = {}

import "./report-overview.vue?vue&type=style&index=0&id=65992340&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65992340"]])

export default __exports__